import CopyListItem from './CopyListItem';

export default CopyListItem;
